import React, {Component} from 'react';

import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import {
  Container,
  Button,
  Loader,
  Dimmer,
  Form,
  Dropdown,
  Input,
  Icon,
} from 'semantic-ui-react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';

import _ from 'lodash';
import SubApplicationSelectForCopy from 'go/components/application/subApplicationSelectForCopy';
import {FuzzySearch} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {Checkbox} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';

import ApiActions from 'go/actions/api';
import uuidv4 from 'uuid/v4';
import REST from 'go/requests/rest';
import {SEARCH_DATA_RADIO_BTNS} from '../application/constants';
import PermissionsUtility from 'go/security/permissionsUtility';
import {produce} from 'immer';

const defaultSearchOption = 'subapplicant';

export class SubApplicationCopy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchOption: undefined,
      originalSubApp: {},
      data: [],
      searchValue: '',
      subOrgs: undefined,
      subApps: [],
      subOrgNames: [],
      orgIds: [],
      programIds: [],
      organizationId: '',
      applicationTypeMap: new Map(),
      organizationTypeMap: new Map(),
      selectedCopySubAppId: '',
      selectedCopySubAppTitle: '',
      selectedCopySubAppType: '',
      selectedCopySubAppTypeDescription: '',
      sectionsToCopy: [],
      selectedSubOrgId: '',
      subAppTitle: '',
      documentControlNumber: '',
      disableSubmitButton: true,
      loadingFuzzy: false,
      loadingSubApps: false,
    };
  }

  componentDidMount = () => {
    const {token} = this.props;
    const permissionData = new PermissionsUtility(token);
    const {programs, organizations} = permissionData;
    this.setState(
      {
        searchOption: defaultSearchOption,
        orgIds: organizations,
        programIds: programs,
        loadingFuzzy: true,
      },
      this.initializeMappings
    );
  };

  initializeMappings = () => {
    this.convertApplicationTypeToMap();
    this.getAllSubApplications();
  };

  createOrganizationTypeToMap = () => {
    const {orgIds} = this.state;
    let organizationTypeMap = new Map();
    const {organizations} = this.props;
    orgIds.map((orgId) => {
      let orgObj = _.find(organizations, function (o) {
        return !o.isOrg && o.orgEntityId == orgId;
      });
      orgObj && organizationTypeMap.set(orgObj.orgEntityId, orgObj.orgDisplayName);
      return;
    });

    let options = _.filter(
      _.map(orgIds, (id) => {
        let displayName = organizationTypeMap.get(parseInt(id, 10));
        return {
          key: `${displayName}-${id}`,
          text: displayName,
          value: id,
        };
      }),
      (option) => option.text !== undefined
    );
    this.setState({
      organizationTypeMap: organizationTypeMap,
      orgOptions: options,
    });
    return;
  };

  createSubOrganizationTypeToMap = () => {
    let subOrganizationTypeMap = new Map();
    let options = [];

    const {organizations} = this.props;
    organizations.map((org) => {
      let displayName = org.displayName;
      let entityId = org.entityId;
      if (!subOrganizationTypeMap.get(parseInt(entityId))) {
        subOrganizationTypeMap.set(entityId, displayName);
        options.push({
          key: `${displayName}-${entityId}`,
          text: displayName,
          value: entityId,
          entityId: entityId,
        });
      }
    });
    this.setState({
      subOrganizationTypeMap: subOrganizationTypeMap,
      subOrgs: options,
    });
  };

  removeUncheckedSectionsAndAttachments = () => {
    const nextState = produce(this.state.originalSubApp, (draft) => {
      let sectionKeys = Object.keys(draft.payload);
      sectionKeys.map((key) => {
        let attachments = _.get(draft.payload[key], 'attachmentIds', undefined);
        if (attachments) {
          draft.payload[key].attachmentIds = [];
        }
        if (
          _.findIndex(this.state.sectionsToCopy, {
            label: key,
            checked: false,
          }) >= 0
        ) {
          draft.payload[key] = undefined;
        }
        return null;
      });
    });
    return nextState;
  };

  createApplicationEntity = async () => {
    const dataToClone = this.removeUncheckedSectionsAndAttachments();
    const mergedSubapplication = produce(dataToClone, (payloadToSend) => {
      let appSubmittedFor =
        this.state.organizationId == this.state.selectedSubOrgId ? 'self' : 'applicant';
      let currentDate = new Date().toString();
      _.set(payloadToSend, 'entityId', undefined);
      _.set(payloadToSend, 'subOrgId', this.state.selectedSubOrgId);
      _.set(payloadToSend, 'organizationId', this.state.organizationId);
      _.set(payloadToSend, 'statusDate', currentDate);
      _.set(payloadToSend, 'statusTimestamp', new Date().toString());
      _.set(payloadToSend, 'payload.applicationTitle', this.state.subAppTitle);
      _.set(
        payloadToSend,
        'payload.applicationTypeDescription',
        this.state.selectedCopySubAppTypeDescription
      );
      _.set(payloadToSend, 'payload.applicationType', this.state.selectedCopySubAppType);
      _.set(payloadToSend, 'payload.applicationSubmittedBy', this.props.loginName);
      _.set(payloadToSend, 'payload.applicationSubmittedFor', appSubmittedFor);
      _.set(
        payloadToSend,
        'payload.documentControlNumber',
        this.state.documentControlNumber
      );
    });

    REST.dynamicData
      .createApplicationEntity(this.props.token, mergedSubapplication)
      .then((response) => response.json())
      .then((resJson) => {
        this.setState((prevState) => ({
          ...prevState,
          newEntityId: resJson.entityId,
        }));
        this.props.history.push(`/subApplication/${this.state.newEntityId}`);
        Promise.resolve();
      })
      .catch((error) => {
        console.error('error');
      });
  };

  handleInputChange = (e) => {
    this.setState({[e.target.name]: e.target.value}, this.validateErrors);
  };

  handleOrgChange = (value) => {
    REST.organization
      .getSubOrganizations({token: this.props.token, orgId: value})
      .then(REST.handler.handleResponse)
      .then((res) => {
        let subOrgList = this.convertSubOrgsToDropdownFormat(res);
        this.setState({
          organizationId: value,
          subOrgNames: subOrgList,
        });
      })
      .then(this.validateErrors);
  };

  handleSubOrgChange = (value) => {
    this.setState((prev) => ({...prev, selectedSubOrgId: value}));
    this.validateErrors();
  };

  convertApplicationTypeToMap = () => {
    let applicationTypeMap = new Map();
    _.forEach(this.props.applicationTypes, (appType) => {
      applicationTypeMap.set(appType.id, appType.description);
    });
    this.setState({applicationTypeMap: applicationTypeMap});
  };

  convertSubOrgsToDropdownFormat = (arr) => {
    let options = _.map(
      _.filter(arr, (item) => !_.isNull(item.displayName)),
      (item) => {
        return {
          key: `${_.replace(item.displayName, / /g, '-')}-${item.organizationId}`,
          text: item.displayName,
          value: item.organizationId,
        };
      }
    );
    return _.sortBy(options, (o) => {
      return _.toLower(o.text);
    });
  };

  handleSearchOptionChange = (event, {value}) => {
    this.setState((prevState) => ({
      ...prevState,
      data: [],
      searchOption: value,
      searchValue: '',
      selectedCopySubAppId: '',
      selectedCopySubAppTitle: '',
      selectedCopySubAppType: '',
      selectedCopySubAppTypeDescription: '',
      sectionsToCopy: [],
      organizationId: '',
      selectedSubOrgId: '',
      subAppTitle: '',
    }));
  };

  handleSelectedCopySubApp = async (id, title, type, typeDesc) => {
    await this.setState({
      selectedCopySubAppId: id,
      selectedCopySubAppTitle: title,
      selectedCopySubAppType: type,
      selectedCopySubAppTypeDescription: typeDesc,
    });
    this.props.getSubApplication(this.props.token, id).then((res) => {
      let listItems = [];
      let data = res.payload.payload;
      let keys = Object.keys(data);

      _.forEach(keys, (key) => {
        if (typeof data[key] === 'object' && key !== 'payload') {
          listItems.push({
            id: uuidv4(),
            label: key,
          });
        }
      });
      // Initially set all sections to be selected for copy
      let forceSelected = listItems.map((item) => {
        item.checked = true;
        return item;
      });
      this.setState((prev) => ({
        ...prev,
        originalSubApp: res.payload,
        sectionsToCopy: forceSelected,
      }));
      this.validateErrors();
    });
  };

  performSearch = async (value) => {
    if (value.length < 1) return [];
    const re = new RegExp(_.escapeRegExp(value), 'i');
    const isMatch = (result) => re.test(result);

    if (this.state.searchOption === 'subapplicant') {
      const mapToObj = (org) => {
        return {
          title: org.text,
          id: org.value,
          type: org.type,
          typeDescription: org.typeDescription,
        };
      };
      const searchData = _.map(this.state.subOrgs, mapToObj);
      return _.filter(searchData, (o) => isMatch(o.title));
    } else if (this.state.searchOption === 'type') {
      const mapToObj = (type) => {
        return {code: type.code, title: type.description, id: type.id};
      };
      const searchData = _.map(this.props.applicationTypes, mapToObj);
      return _.filter(searchData, (o) => isMatch(o.title));
    } else if (this.state.searchOption === 'title') {
      const mapToObj = (subapp) => {
        return {
          title: subapp.applicationTitle,
          id: subapp.entityId,
          type: subapp.applicationType,
          typeDescription: subapp.applicationTypeDescription,
        };
      };
      const searchData = _.map(this.state.subApps, mapToObj);
      return _.filter(searchData, (o) => isMatch(o.title));
    }
  };

  handleSubApplicationSelectionChange = (value) => {
    let data = this.state.data;
    _.forEach(data, (subApplication) => {
      if (subApplication.entityId === value) {
        subApplication.checked = !subApplication.checked;
      }
    });
    this.setState((prevState) => ({
      ...prevState,
      data: data,
    }));
  };

  handleResultSelect = (result) => {
    this.setState({
      searchValue: result,
      selectedCopySubAppType: result.id,
    });
    if (this.state.searchOption === 'subapplicant') {
      this.getSubAppsBySubOrgId(result.id);
    } else if (this.state.searchOption === 'type') {
      this.getSubAppsByType(result.id);
    } else if (this.state.searchOption === 'title') {
      this.getSubApplicationByTitle(result);
    }
  };

  convertToApplicationList = (orgId, data, newItems) => {
    let newData = _.filter(
      newItems,
      (item) => _.findIndex(data, (o) => o.entityId == item.entityId) < 0
    );
    return newData.map((item) => ({
      entityId: item.entityId,
      applicationTitle: item.payload.applicationTitle,
      applicationType: item.payload.applicationType,
      applicationTypeDescription: item.payload.applicationTypeDescription || '',
      orgId: orgId,
    }));
  };

  getSubAppsBySubOrgId = (subOrgId) => {
    this.setState({loadingSubApps: true});
    const {programIds, orgIds} = this.state;
    let data = [];
    let allPromises = [];

    for (let oid = 0; oid < orgIds.length; oid++) {
      let orgId = orgIds[oid];
      let wrappedPromise = new Promise((resolve, reject) => {
        REST.search
          .getSubAppsByOrgIdBySubOrgIdAndByCategoryId(
            this.props.token,
            orgId,
            this.props.categoryId,
            subOrgId
          )
          .then((res) => res.json())
          .then((resJson) => {
            if (resJson.items.length >= 0) {
              let newData = this.convertToDisplayList(orgId, data, resJson.items);
              data = [...data, ...newData];
              resolve();
            } else {
              reject(resJson);
            }
          })
          .catch((err) => {
            if (err.status === 404) {
              resolve([]);
            } else {
              reject(err);
            }
          });
      });
      allPromises.push(wrappedPromise);
    }

    Promise.all(allPromises)
      .then(() => {
        this.setState({
          loadingSubApps: false,
          data: data,
        });
        return;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  convertToDisplayList = (orgId, data, newItems) => {
    let newData = _.filter(newItems, (item) => {
      let value = _.findIndex(data, (o) => o.entityId == item.entityId);
      return value < 0;
    });
    return newData.map((item) => {
      return {
        entityId: item.entityId,
        applicationTitle: item.payload.applicationTitle,
        applicationType: item.payload.applicationType,
        applicationTypeDescription: item.payload.applicationTypeDescription,
        orgId: orgId,
      };
    });
  };

  getSubApplicationByTitle = (subApp) => {
    this.handleSelectedCopySubApp(
      subApp.id,
      subApp.title,
      subApp.type,
      subApp.typeDescription
    );
  };

  getSubAppsByType = (applicantType) => {
    this.setState({loadingSubApps: true});
    const {programIds, orgIds} = this.state;
    let data = [];
    let allPromises = [];

    for (let oid = 0; oid < orgIds.length; oid++) {
      let orgId = orgIds[oid];
      let wrappedPromise = new Promise((resolve, reject) => {
        REST.search
          .getSubAppsByOrgIdByTypeAndByCategoryId(
            this.props.token,
            orgId,
            this.props.categoryId,
            applicantType
          )
          .then((res) => res.json())
          .then((resJson) => {
            if (resJson.items.length >= 0) {
              let newData = this.convertToApplicationList(orgId, data, resJson.items);
              data = [...data, ...newData];
              resolve();
            } else {
              reject(resJson);
            }
          })
          .catch((err) => {
            if (err.status === 404) {
              resolve([]);
            } else {
              reject(err);
            }
          });
      });
      allPromises.push(wrappedPromise);
    }

    Promise.all(allPromises)
      .then(() => {
        this.setState({
          loadingSubApps: false,
          data: data,
        });
        return;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getAllSubApplications = () => {
    const {programIds, orgIds} = this.state;
    const {token} = this.props;

    let data = [];
    let allPromises = [];
    let newData = [];
    this.setState({
      data: data,
    });

    for (let oid = 0; oid < orgIds.length; oid++) {
      let orgId = orgIds[oid];
      let wrappedPromise = new Promise((resolve, reject) => {
        REST.search
          .getSubAppsByOrgIdAndByCategoryId(
            token,
            orgId,
            null,
            this.props.categoryId,
            'applicant'
          )
          .then((res) => res.json())
          .then((resJson) => {
            resolve({resJson, orgId});
          })
          .catch((err) => {
            if (err.status === 404) {
              Promise.resolve([]);
            } else {
              Promise.reject(err);
            }
          });
      });
      allPromises.push(wrappedPromise);
    }

    Promise.all(allPromises)
      .then((response) => {
        response.forEach((element) => {
          if (element.resJson.items.length >= 0) {
            newData = this.convertToApplicationList(
              element.orgId,
              data,
              element.resJson.items
            );
            data = [...data, ...newData];
          }
        });
        this.setState({
          loadingFuzzy: false,
          subApps: data,
        });
        this.createOrganizationTypeToMap();
        this.createSubOrganizationTypeToMap();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  updateSelectedList = async () => {
    let newArray = [...this.state.sectionsToCopy];
    await _.forEach(newArray, (entry) => {
      entry.checked = !!entry.checked;
    });
    this.setState((prev) => ({...prev, sectionsToCopy: newArray}));
    this.validateErrors();
  };

  validateErrors = () => {
    const {
      selectedCopySubAppId,
      selectedCopySubAppTitle,
      sectionsToCopy,
      organizationId,
      selectedSubOrgId,
      subAppTitle,
    } = this.state;

    let disable =
      selectedCopySubAppId === '' ||
      selectedCopySubAppTitle === '' ||
      sectionsToCopy.length === 0 ||
      organizationId === '' ||
      selectedSubOrgId === '' ||
      subAppTitle === '';

    this.setState({disableSubmitButton: disable});
  };

  handleToggleSelect = (label, value) => {
    let copyList = [...this.state.sectionsToCopy];
    let index = _.findIndex(copyList, (item) => item.label === label);
    if (index >= 0) {
      copyList[index].checked = value;
    }

    this.setState((prev) => ({...prev, sectionsToCopy: copyList}));
    this.validateErrors();
  };

  render() {
    const {sectionsToCopy} = this.state;
    return (
      <Container id="subAppCopy">
        <div id="subAppCopyHeaderDiv">
          <h4>Search</h4>
          <h5>Search for the subapplication you wish to add</h5>
          <p>
            You can add a subapplication by searching for a subapplication title, type or
            subapplicant.
          </p>
        </div>
        <br />
        <br />
        <Form>
          <Dimmer active={this.state.loadingFuzzy} inverted>
            <Loader inverted>Loading</Loader>
          </Dimmer>
          <FuzzySearch
            name="subapplicationCopy"
            radioBtns={SEARCH_DATA_RADIO_BTNS}
            searchWidth={16}
            numColumns={3}
            radioSelectedValue={this.state.searchOption}
            performSearch={this.performSearch}
            handleRadioSelection={this.handleSearchOptionChange}
            handleResultSelect={this.handleResultSelect}
          />
          {this.state.searchOption !== 'title' && (
            <React.Fragment>
              <Dimmer active={this.state.loadingSubApps} inverted>
                <Loader inverted>Loading</Loader>
              </Dimmer>
              <SubApplicationSelectForCopy
                data={this.state.data}
                applicationTypeMap={this.state.applicationTypeMap}
                organizationTypeMap={this.state.organizationTypeMap}
                handleChange={this.handleSubApplicationSelectionChange}
                selectedCopySubAppId={this.state.selectedCopySubAppId}
                handleSelectedCopySubApp={this.handleSelectedCopySubApp}
              />
            </React.Fragment>
          )}
          {this.state.selectedCopySubAppId !== '' && (
            <div id="selected-application">
              <h5>Selected application</h5>
              <h3>{this.state.selectedCopySubAppTitle}</h3>
              <h5>Select sections of the subapplication</h5>
              <p>Language to be provided by HMA team...</p>
              {sectionsToCopy.length === 0 ? (
                <h4>No sections available to copy</h4>
              ) : (
                <div id="checkbox-list-container">
                  <div className="checkbox-list-body">
                    {sectionsToCopy.map((item) => (
                      <Checkbox
                        key={item.id}
                        label={item.label}
                        disabled={item.disabled}
                        handleChange={this.handleToggleSelect}
                        checked={item.checked}
                      />
                    ))}
                  </div>
                </div>
              )}
              <hr />
              <h5>Organization name</h5>
              <Dropdown
                fluid
                selection
                options={this.state.orgOptions}
                onChange={(e, {value}) => this.handleOrgChange(value)}
              />
              <h5>Suborganization name</h5>
              <Dropdown
                fluid
                selection
                options={this.state.subOrgNames}
                onChange={(e, {value}) => this.handleSubOrgChange(value)}
              />
              <h5>Subapplication title</h5>
              <Input
                focus
                name="subAppTitle"
                value={this.state.subAppTitle}
                onChange={this.handleInputChange}
              />
              <h5>
                Document control number <i style={{fontWeight: 'normal'}}>(Optional)</i>
              </h5>
              <Input
                focus
                name="documentControlNumber"
                value={this.state.documentControlNumber}
                onChange={this.handleInputChange}
              />
              <br />
              <br />
              <br />
              <Button
                color={'blue'}
                value={'value'}
                type={'type'}
                onClick={this.createApplicationEntity}
                disabled={this.state.disableSubmitButton}
                width={'medium'}
              >
                Start your subapplication
              </Button>
              <br />
              <br />
              <Link to="/">
                <Icon name="cancel" />
                Cancel
              </Link>
            </div>
          )}
        </Form>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    auth: state.auth,
    applicationTypes: _.get(
      state,
      'dynamicComponent.context.loadRefApplicantType.APPLICATION_TYPE',
      null
    ),
    organizations: _.get(state, 'dynamicComponent.context.orgs', null),
    loginName: state.auth.loginName,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getSubApplication: (token, entityId) => {
    const action = ApiActions.dynamicData.getDataByEntityId(
      token,
      entityId,
      'application'
    );
    const res = dispatch(action);
    return res;
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(connectDynamic(SubApplicationCopy))
);
